module.exports = __webpack_public_path__ + "static/media/lb-search.f2af02b5.svg";